import {
  BrowseSubscriptionPlanRequest,
  BrowseSubscriptionPlanResponse,
  PlanInterval,
  SubscriptionStatus,
} from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { PLAN_ROOT_ENDPOINT_UM } from '@aibees/shared/workspace/constants/endpoints';

export function useBrowseSubscriptionPlanApi(
  interval?: PlanInterval,
  family?: string
) {
  const wid = useWorkspace()?.id;

  // `wid` is in the key because the url embeds it, and gated on `enabled` so we
  // don't fire a request at `/…/undefined/…` before useWorkspace() resolves.
  return useBaseQuery<
    BrowseSubscriptionPlanRequest,
    BrowseSubscriptionPlanResponse
  >(
    [useBrowseSubscriptionPlanApi.name, wid, interval, family],
    {
      url: PLAN_ROOT_ENDPOINT_UM.replace(':wid', String(wid)),
      params: {
        status: SubscriptionStatus.ACTIVE,
        interval,
        family,
      },
    },
    { enabled: !!wid }
  );
}
